import React from 'react';
import PropTypes from 'prop-types';

import css from './ProjectInfoBlock.module.scss';

function formatUrl(url) {
    return url
        .replace('http://', '')
        .replace('https://', '')
        .replace(/\/$/, '');
}

const Section = ({ title, text, url, urls }) => (
    <div className={css.info}>
        <strong>{`${title}: `}</strong>
        {text && <span dangerouslySetInnerHTML={{ __html: text}} />}
        {url && <a href={url} target="_blank" rel="noopener noreferrer">{formatUrl(url)}</a>}
        {urls && (
            <ul>
                {urls.map((u, index) => (
                    <li key={index}>
                        <a
                            key={index}
                            href={u.href}
                            target={u.target}
                            title={u.title}
                        >{u.text}</a>
                    </li>
                ))}
            </ul>
        )}
    </div>
);

Section.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    url: PropTypes.string,
    urls: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string.isRequired,
        target: PropTypes.string,
        text: PropTypes.string.isRequired,
        title: PropTypes.string,
    })),
};

// Remove sections that has an empty text, url and urls value
const filterEmptySections = s => s.text || s.url || s.urls;

const ProjectInfoBlock = ({
    sections,
}) => (
    <div className={css.block}>
        <div className={css.column}>
            {sections.filter(filterEmptySections).map(section => (
                <Section
                    key={section.title}
                    {...section}
                />
            ))}
        </div>
    </div>
);

ProjectInfoBlock.propTypes = {
    sections: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        text: PropTypes.string,
        url: PropTypes.string,
    })).isRequired
};

export default ProjectInfoBlock;



// WEBPACK FOOTER //
// ./src/components/ProjectInfoBlock/ProjectInfoBlock.jsx